import React from 'react';
import styled from 'styled-components';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
  titleExtra?: React.ReactNode;
  // Content rendered above the title (proto's `.gv-eyebrow-row`), e.g. the
  // Global View Wine/Spirits category toggle.
  eyebrow?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  children,
  titleExtra,
  eyebrow
}) => (
  <Header>
    <div>
      {eyebrow}
      <Title>
        {title}
        {titleExtra}
      </Title>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </div>
    {children && <Actions>{children}</Actions>}
  </Header>
);

const Header = styled.section`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 24px;
  gap: 16px;
  flex-wrap: wrap;
`;

const Title = styled.h1`
  font-family: var(--font-serif);
  font-size: 28px;
  font-weight: 500;
  letter-spacing: -0.02em;
  color: var(--ink);
  margin: 0 0 6px;
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Subtitle = styled.p`
  font-size: 14px;
  color: var(--ink-muted);
  margin: 0;
  max-width: 620px;
  line-height: 1.5;
`;

const Actions = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
